module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container noselect",
    class: (this.item.done ? 'done' : '') + (this.item.deleted ? ' deleted' : ''),
    attrs: {
      "id": 'item-card-' + _vm.id
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "option right",
    attrs: {
      "id": 'ro-card-' + _vm.id
    }
  }, [_c('i', {
    staticClass: "trash outline icon"
  })]), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.item.label))]), _c('p', {
    staticClass: "short"
  }, [_c('nobr', [_vm._v(_vm._s(_vm.get_short_desc()))])], 1), _c('p', {
    staticClass: "long"
  }, [_vm._v(_vm._s(_vm.item.desc))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option left"
  }, [_c('i', {
    staticClass: "checkmark icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d5adfc7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemCard.vue
// module id = 52
// module chunks = 0